import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from 'src/app/core/widgets/grid/grid.component';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import { take, catchError } from 'rxjs/operators';
import moment from 'moment';
import { Warehouse } from '../../models/warehouse.model';
import { WarehouseService } from '../../services/warehouse.service';

@Component({
    selector: 'app-locations',
    templateUrl: './locations.component.html',
    styleUrls: ['./locations.component.scss'],
    standalone: false
})
export class LocationsComponent implements OnInit {

  // Grid reads this.filters when it queries but has no ngOnChanges, so changing
  // the warehouse has to ask it to re-query.
  @ViewChild(GridComponent)
  grid: GridComponent;

  warehouses: Warehouse[] = [];
  selectedWarehouseId: number = -1;

  buttons: GridButton[] = [
    {label: 'Edit', link: '/warehousing/locations/edit/:id', type: 'btn-warning',} as GridButton,
    {label: 'Label', link: '/warehousing/locations/label/:id', type: 'btn-secondary',} as GridButton,
  ]

  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Warehouse', field: 'warehouse.name'} as GridColumn,
    {active: true, label: 'Aisle', field: 'aisle'} as GridColumn,
    {active: true, label: 'Shelf', field: 'shelf'} as GridColumn,
    {active: true, label: 'Description', field: 'description'} as GridColumn,
    {active: true, label: 'Created At', field: 'createdAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn,
    {active: true, label: 'Updated At', field: 'updatedAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn
  ];

  relationships: string[] = ['warehouse'];

  filters: GridFilter[] = []

  searchFields: any = ['aisle','shelf','description','warehouse.name'];

  searchFilters: GridSearchFilter[] = [
    {
      field: 'warehouse.name',
      label: 'Warehouse',
    } as GridSearchFilter,
    {
      field: 'aisle',
      label: 'Aisle',
    } as GridSearchFilter,
    {
      field: 'shelf',
      label: 'Shelf',
    } as GridSearchFilter,
    {
      field: 'description',
      label: 'Description',
    } as GridSearchFilter,
  ]

  constructor(private warehouseService: WarehouseService) { }

  ngOnInit(): void {
    this.loadWarehouses();
  }

  loadWarehouses() {
    this.warehouseService.getAllWarehouses()
    .pipe(take(1))
    .pipe(catchError((e) => {
      if (e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load warehouses");
      return e;
    }))
    .subscribe((data: Warehouse[]) => {
      this.warehouses = data;
    })
  }

  onWarehouseChanged(warehouseId: number) {
    this.selectedWarehouseId = +warehouseId;

    if (this.selectedWarehouseId === -1) {
      this.filters = [];
    } else {
      this.filters = [{field: 'warehouseId', condition: 'eq', value: this.selectedWarehouseId} as GridFilter];
    }

    this.reloadGrid();
  }

  private reloadGrid() {
    if (!this.grid) {
      return;
    }

    this.grid.filters = this.filters;
    this.grid.paginationService.setPage(1);
    this.grid.newPage = 1;
    this.grid.getRecordsForEntity();
  }
}
